import React from "react";
import BusyIndicator from "./components/busyIndicator";
import {
  Experimental_CssVarsProvider as CssVarsProvider,
  experimental_extendTheme as extendTheme,
} from "@mui/material/styles";
import { colors } from "./maps/colors";
import Message from "./components/Message";
import { SnackbarProvider } from "notistack";
import { ZibiContextProvider } from "./zibi/Context";
import { Route, Routes } from "react-router-dom";
import AuthMiddleware from "./routes/middlewares/AuthMiddleware";
import AdminLayout from "./routes/layouts/AdminLayout";
import UsersPage from "./routes/admin/UsersPage";
import ShoppersPage from "./routes/admin/ShoppersPage";
import DistributorsPage from "./routes/admin/DistributorsPage";
import InstallersPage from "./routes/admin/InstallersPage";
import ProductsPage from "./routes/admin/ProductsPage";
import InventoryPage from "./routes/admin/InventoryPage";
import EdgesPage from "./routes/admin/EdgesPage";
import StoresPage from "./routes/admin/StoresPage";
import AdminLoginPage from "./routes/admin/AdminLoginPage";
import SensorsPage from "./routes/admin/SensorsPage";
import DataHandle from "./routes/middlewares/DataHandle";
import AlertsPage from "./routes/admin/AlertsPage";
import AlertPage from "./routes/admin/AlertPage";
import AIReportPage from "./routes/admin/AIReportPage";
import FirmwarePage from "./routes/admin/FirmwarePage";
import StoreShelves from "./routes/admin/StoreShelves";
import InventoryManagementPage from "./routes/admin/InventoryManagementPage";
import ImAlertsPage from "./routes/admin/ImAlertsPage";
import ImDashboardMain from "./routes/admin/ImDashboardMain";
import SigmaBusketPage from "./routes/admin/SigmaBusketPage";
import MainInstallerDashboardPage from "./routes/admin/MainInstallerDashboardPage";
import PlanogramPage from "./components/planograms/PlanogramPage";
import FieldsPage from "./components/fields/FieldsPage";
import FieldDetailPage from "./components/fields/Field-details";
import FloorPage from "./components/floor/floorPage";
import LogsPage from "./components/app-logs/logsPage";
import AntiThievesPage from "./components/anti-thieves/antiThievesPage";

 




import DebugPage from "./routes/admin/DebugPage";

const theme = extendTheme({
  colorSchemes: {
    light: {
      palette: {
        primary: {
          main: colors.GREEN,
        },
      },
    },
    dark: {
      palette: {
        primary: {
          main: colors.LIGHT_ORANGE,
        },
      },
    },
  },
});

function App() {
  return (
    <ZibiContextProvider>
      <SnackbarProvider maxSnack={10}>
        <CssVarsProvider theme={theme}>
          <DataHandle />
          <BusyIndicator />
          <div id="customPortal"></div>
          <Message />
          <Routes>
            <Route index element={<AdminLoginPage />} />
            <Route
              element={
                <AuthMiddleware>
                  <AdminLayout />{" "}
                </AuthMiddleware>
              }
            >
              <Route path="/shoppers" element={<ShoppersPage />} />
              <Route path="/distributors" element={<DistributorsPage />} />
              <Route path="/installers" element={<InstallersPage />} />
              <Route path="/products" element={<ProductsPage />} />
              <Route path="/inventory" element={<InventoryPage />} />
              <Route path="/edges" element={<EdgesPage />} />
              <Route path="/stores" element={<StoresPage />} />
              <Route path="/stores2" element={<MainInstallerDashboardPage />} />
              <Route path="/sensors" element={<SensorsPage />} />
              <Route path="/users" element={<UsersPage />} />
              <Route path="/alert" element={<AlertPage />} />
              <Route path="/debug" element={<DebugPage />} />
              <Route path="/planogram" element={<PlanogramPage />} />
              <Route path="/tv/fields" element={<FieldsPage />} />
              <Route path="/tv/fields/:edgeId/field/:id" element={<FieldDetailPage />} />
              <Route path="/floors/" element={<FloorPage />} />
              <Route path="/logs/" element={<LogsPage />} />
              <Route path="/tv/anti-thieves" element={<AntiThievesPage />} />

              



              <Route path="/alerts" element={<AlertsPage />} />
              <Route path="/ai-report" element={<AIReportPage />} />
              <Route path="/firmware" element={<FirmwarePage />} />
              <Route path="/store-shelves" element={<StoreShelves />} />
              <Route
                path="/inventory-management"
                element={<InventoryManagementPage />}
              />
              <Route path="/im-alerts" element={<ImAlertsPage />} />
              <Route path="/im-main" element={<ImDashboardMain />} />
              <Route path="/sig-busket" element={<SigmaBusketPage />} />
            </Route>
            <Route path="/login" element={<AdminLoginPage />} />
          </Routes>
        </CssVarsProvider>
      </SnackbarProvider>
    </ZibiContextProvider>
  );
}

export default App;
